module.exports = __webpack_public_path__ + "img/seminar5.532fa4ab.jpg";